import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  CircularProgress,
  Checkbox,
  FormControl,
  FormControlLabel,
  RadioGroup,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { TextField, Button, Tooltip, Typography } from '@material-ui/core';
import ChevronRight from '@material-ui/icons/ChevronRight';
import ExpandMore from '@material-ui/icons/ExpandMore';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import DescriptionIcon from '@material-ui/icons/Description';
import PropTypes, { object } from 'prop-types';
import React, { useState, useContext, useEffect } from 'react';
import { withRouter } from 'react-router';
import { Autocomplete } from '../Autocomplete';
import Select, { components } from 'react-select';
import cn from 'classnames';
import styles from './ClientPriceOverrides.styles';
import { AppContext } from '../../AppContext';
import useEnvironmentTheme from '../../hooks/useEnvironmentTheme';
import SearchIcon from '@material-ui/icons/Search';
import Error from '@material-ui/icons/Error';
import {
  getClientList,
  getClientPriceOverrideProducts,
  getClientPriceOverrides,
  updateClientPriceOverrides,
  getClientSupplements,
  getClientSuppOverrides,
  getByteFileForClientPriceOverrides,
  getStateOptions,
  getStates,
} from '../../services';
import ColoredCheckbox from '../ColoredInputs/ColoredCheckbox';
import ColoredRadio from '../ColoredInputs/ColoredRadio';
import ColoredSwitch from '../ColoredInputs/ColoredSwitch';
import InfoTooltip from '../InfoTooltip';
import { ConfirmationDialog } from '../ConfirmationDialog';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/core/styles';
import { LocalConvenienceStoreOutlined } from '@material-ui/icons';
import { curry } from 'lodash';
import Switch from '@material-ui/core/Switch';
import { downloadExcelFileToBrowser } from '../../helpers';
const useStyles = makeStyles({
  confirmationModal: {
    width: '90vw',
  },
});
// TODO: create wrapping for additional configuration items
const INPUT_ROW_HEIGHT = 35;

const priceOverrideInputs = [
  {
    field: 'tier1',
    label: 'Tier 1',
    type: 'number',
  },
  {
    field: 'tier2',
    label: 'Tier 2',
    type: 'number',
  },
  {
    field: 'tier3',
    label: 'Tier 3',
    type: 'number',
  },
  {
    field: 'tierDIY',
    label: 'DIY',
    type: 'number',
  },
];

const productOptionsInputs = [
  {
    field: 'alias',
    label: 'Report Name Alias',
    type: 'text',
  },
  {
    field: 'callAhead',
    label: 'Require Call ahead',
    type: 'checkbox',
  }, {
    field: 'removeBetterView',
    label: 'Remove BetterView',
    type: 'checkbox'
  },
  {
    field: 'removeHazardHub',
    label: 'Remove HazardHub',
    type: 'checkbox'
  },
  {
    field: 'removeQuantarium',
    label: 'Remove Quantarium',
    type: 'checkbox'
  },
  {
    type: 'heading',
    label: 'Phone Interview Options',
  },
  {
    field: 'phoneInterview',
    label: 'Require Phone Interview',
    type: 'checkbox',
  },
  {
    field: 'incompleteInterviewFrstipend',
    label: 'Interview Completed Field Rep Reduction',
    type: 'number'
  },
  {
    field: 'maxLocations',
    label: 'Max Number Of Locations',
    type: 'number'
  },
   
  {
    field: 'scheduleRequired',
    label: 'Schedule Required',
    type: 'checkbox',
  },
  {
    type: 'heading',
    label: 'IQ Options',
  },
  {
    field: 'homeOwnerDueDays',
    label: 'Owner Due Days',
    type: 'number',
  },
  {
    field: 'disableInteriorPhotos',
    label: 'Disable Interior Photos',
    type: 'checkbox',
  },
  {
    field: 'iqOwnerRejectRadioGroup',
    type: 'iqOwnerRejectRadioGroup',
    label: '',
  },
  {
    field: 'convertToProductId',
    label: 'Convert To Product',
    type: 'dropdown',
  },
  {
    field: 'dueDateDays',
    label: 'Due Date Days',
    type: 'number',
  },
];

const IQ_OPTION_FIELDS = new Set([
  'convertProduct',
  'convertToProductId',
  'homeOwnerDueDays',
  'dueDateDays',
  'cancelQVOnHOReject',
  'convertToVirtualOnReject',
  'disableInteriorPhotos',
]);

const IQ_OPTIONS_ONLY_TOOLTIP = 'Only valid for IQ Products';

const getIqOwnerRejectRadioValue = pd => {
  if (!pd) return '';
  if (pd.cancelQVOnHOReject) return 'cancel';
  if (pd.convertToVirtualOnReject) return 'virtual';
  if (pd.convertProduct) return 'convertProduct';
  return '';
};

/** Align product override rows with API camelCase and strip legacy/typo keys before merge or save */
const normalizePriceOverrideProductForApi = product => {
  const merged = { ...product };
  if (merged.convertToVirtualOnReject == null && merged.convertToVirtualOnHOReject != null) {
    merged.convertToVirtualOnReject = merged.convertToVirtualOnHOReject;
  }
  delete merged.convertToVirtualOnHOReject;
  if (merged.cancelQVOnHOReject == null && merged.cancelQvonHoreject != null) {
    merged.cancelQVOnHOReject = merged.cancelQvonHoreject;
  }
  delete merged.cancelQvonHoreject;
  if (merged.disableInteriorPhotos == null && merged.DisableInteriorPhotos != null) {
    merged.disableInteriorPhotos = merged.DisableInteriorPhotos;
  }
  delete merged.DisableInteriorPhotos;
  return merged;
};

const supplementFormInput = [
  {
    field: 'price',
    label: 'Price',
  },
];

// track the count of selected options from the <Autocomplete>
let counter = 0;
const ValueContainer = React.memo(({ children, getValue, ...props }) => {
  counter = getValue().length + ' selected';

  return <components.ValueContainer {...props}>{children}</components.ValueContainer>;
});

const ClientPriceOverrides = ({ classes }) => {
  // Environment theme
  const envTheme = useEnvironmentTheme();
  
  // list variables
  const [products, setProducts] = useState([]);
  const [supplements, setSupplements] = useState([]);
  const [columnData, setColumnData] = useState([]);
  const [supplementData, setSupplementData] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);
  const [clientPriceOverrides, setClientPriceOverrides] = useState({});
  const [stateOptions, setStateOptions] = useState([]);

  // loading
  const [productsLoading, setProductsLoading] = useState(false);
  const [clientOptionsLoading, setClientOptionsLoading] = useState(false);
  const [clientPriceOverridesLoading, setClientPriceOverridesLoading] = useState(false);
  const [formIsSaving, setFormIsSaving] = useState(false);

  // selected variables
  const [selectedPropertyTypeId, setSelectedPropertyTypeId] = useState(null);
  const [selectedProductCategoryId, setSelectedProductCategoryId] = useState(null);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [selectedClient, setSelectedClient] = useState(
    null,
    // {
    //   label: 'Cincinnati Insurance (Personal Lines) (CICTE)',
    //   value: 102,
    // },
  );
  const [selectedSupplementName, setSelectedSupplementName] = useState(null);
  const [selectedFormHeaderId, setSelectedFormHeaderId] = useState(null);

  let [errorType, setErrorType] = useState([]);
  let [errorCategory, setErrorCategory] = useState([]);
  let [errorName, setErrorName] = useState([]);

  const [selectedClients, setSelectedClients] = useState([]);
  const [filteredNameColumnData, setFilteredNameColumnData] = useState([]);
  const [filteredSupplementData, setFilteredSupplementData] = useState([]);
  const [filteredCategoryColumnData, setFilteredCategoryColumnData] = useState([]);
  const [filteredCategorySupplementData, setFilteredCategorySupplementData] = useState([]);

  const [wipeUpdateCreate, SetwipeUpdateCreate] = useState(false);
  const [clearCreate, setClearCreate] = useState(false);
  const [updateCreate, setUpdateCreate] = useState(true);
  // control whether the form is in client edit mode or JMI default edit mode
  const [clientSingleSelectEnabled, setClientSingleSelectEnabled] = useState(true);

  // control whether the form is in selected products only mode
  const [selectProduct, setSelectProduct] = useState(true);

  // control whether client is looking at supplements or products
  const [supplementView, setSupplementView] = useState(false);

  // track modified answer values for the current question
  const [validProductIds, setValidProductIds] = useState(new Set());
  const [validFormHeaderIds, setValidFormHeaderIds] = useState(new Set());
  const [activeProduct, setActiveProduct] = useState(null);

  // control the save changes modal
  const [showSaveChangesModal, setSaveChangesModal] = useState(false);
  const [saveChanges, setSaveChanges] = useState(false);
  const [changes, setChanges] = useState({});
  const [exportingData, setExportingData] = useState(false);
  const [selectedStates, setSelectedStates] = useState([]);
  const [stateDropdownOpen, setStateDropdownOpen] = useState(false);
  const [payableAmount, setPayableAmount] = useState('');
  const [frPayableRows, setFrPayableRows] = useState([
    { id: 1, selectedStates: [], dropdownOpen: false, amount: '' }
  ]);
  const [allProductFRPayables, setAllProductFRPayables] = useState({});
  const [expandedProducts, setExpandedProducts] = useState([]);
  /**
   * COMPUTED
   */
  const formIsReady = !!selectedClient || selectedClients.length;
  const formIsLoading = productsLoading || clientOptionsLoading || clientPriceOverridesLoading;

  const { dispatch } = useContext(AppContext);

  /**
   * FUNCTIONS: API
   */
  const getProductsAsync = async () => {
    try {
      setProductsLoading(true);
      const results = await getClientPriceOverrideProducts();
      setProducts(results);
    } catch (error) {
      console.log(error);
    }
    setProductsLoading(false);
  };

  const getSupplementsAsync = async () => {
    try {
      setProductsLoading(true);
      const results = await getClientSupplements();

      setSupplements(results);
    } catch (error) {
      console.log(error);
    }
    setProductsLoading(false);
  };

  const getPriceOverridesByClientIdAsync = async clientId => {
    try {
      setClientPriceOverridesLoading(true);

      const clientOverrides = await getClientPriceOverrides(clientId);

      setClientPriceOverridesLoading(false);
      return clientOverrides;
    } catch (error) {
      console.log(error);
      setClientPriceOverridesLoading(false);
      return [];
    }
  };

  const getSuppOverridesByClientIdAsync = async clientId => {
    try {
      setClientPriceOverridesLoading(true);

      const clientOverrides = await getClientSuppOverrides(clientId);

      setClientPriceOverridesLoading(false);
      return clientOverrides;
    } catch (error) {
      console.log(error);
      setClientPriceOverridesLoading(false);
      return [];
    }
  };

  const getClientListAsync = async () => {
    try {
      setClientOptionsLoading(true);
      let results = await getClientList();
      results = results
        .map(c => ({
          label: `${c.name} (${c.code})`,
          value: c.id,
        }))
        .sort((a, b) => (a.label < b.label ? -1 : 0));
      setClientOptions(results);
    } catch (error) {
      console.log(error);
    }
    setClientOptionsLoading(false);
  };

  const getStatesAsync = async () => {
    try {
      const results = await getStateOptions();
      setStateOptions(results);
    } catch (error) {
      console.log(error);
    }
  };

  const saveOverridesAsync = async overrides => {
    const flattened = flattenColumnData();
    const flattenedSupplements = flattenSupplementData();

    // Add FR Additional Payables data to products (same logic as in handleSaveChangesButton)
    const productsWithFRPayables = flattened
      .filter(product => validProductIds.has(product.productId))
      .map(product => {
        // Get FR payables for each product from stored data
        let frPayables = undefined;
        
        // Check if this product has stored FR payables
        const productPayables = allProductFRPayables[product.productId];
        
        if (productPayables) {
          const validFRPayables = productPayables
            .filter(row => row.selectedStates.length > 0 && row.amount)
            .map(row => {
              const stateIds = row.selectedStates.map(stateId => parseInt(stateId));
              const amount = parseFloat(row.amount) || 0;
              
              //console.log(`Backend save - FR Payable row - StateIds: ${stateIds}, Amount: ${amount}`);
              
              return {
                productId: product.productId,
                stateIds: stateIds,  // Array of state IDs
                payableAmount: amount
              };
            });
          
          frPayables = validFRPayables.length > 0 ? validFRPayables : undefined;
          //console.log(`Backend save - Product ${product.productId} final FR payables:`, frPayables);
        }

        return {
          ...normalizePriceOverrideProductForApi(product),
          frAdditionalPayables: frPayables,
        };
      });

    const vm = clientSingleSelectEnabled
      ? {
          clientIds: [selectedClient.value],
          validProducts: productsWithFRPayables,
          validSupplements: flattenedSupplements.filter(supp => validFormHeaderIds.has(supp.formHeaderId)),
        }
      : {
          clientIds: selectedClients.map(client => client.value),
          validProducts: productsWithFRPayables,
          validSupplements: flattenedSupplements.filter(supp => validFormHeaderIds.has(supp.formHeaderId)),
        };

    try {
      setFormIsSaving(true);
      //console.log('Sending to backend - VM object:', vm);
      //console.log('Products with FR payables being sent:', vm.validProducts.filter(p => p.frAdditionalPayables));
      const success = await updateClientPriceOverrides(vm, wipeUpdateCreate);

      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'success',
          message: 'Pricing saved successfully!',
        },
      });

      // only reset the state if a single client is selected (since the data shouldn't get wiped)
      if (clientSingleSelectEnabled) {
        setupInitialClientState();
      }
    } catch (error) {
      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'error',
          message: typeof error === 'string' ? error : error.message || 'Pricing failed to save...',
        },
      });
    }

    setSaveChangesModal(false);
    setFormIsSaving(false);
  };

  const handleExportData = async () => {
    setExportingData(true);
    const res = await getByteFileForClientPriceOverrides();
    const dateForExcelFile = new Date();
    const download = downloadExcelFileToBrowser(res, `ClientProductConfigurations-${dateForExcelFile}.xlsx`);
    dispatch({
      type: 'SET_SNACKBAR',
      snackbar: {
        isOpen: true,
        variant: 'success',
        message: 'Client product configurations exported succesfully, check your downloads folder.',
      },
    });
    setExportingData(false);
  };

  const handleSaveChangesButton = () => {
    // Create updated FR payables object that includes current product
    let updatedFRPayables = { ...allProductFRPayables };
    
    // Manually save current FR payables before processing
    //console.log('Save button clicked - selectedProductId:', selectedProductId);
    //console.log('Save button clicked - frPayableRows:', frPayableRows);
    
    if (selectedProductId && frPayableRows.some(row => row.selectedStates.length > 0 || row.amount)) {
      //console.log('Manually saving FR payables for product:', selectedProductId);
      updatedFRPayables[selectedProductId] = [...frPayableRows];
      //console.log('Manual save - Updated FR payables object:', updatedFRPayables);
      
      // Add this product to validProductIds if it has FR payables data
      if (!validProductIds.has(selectedProductId)) {
        //console.log('Adding FR payables product to valid products:', selectedProductId);
        validProductIds.add(selectedProductId);
        setValidProductIds(new Set(validProductIds)); // Update state
      }
      
      // Also update the state for future use
      setAllProductFRPayables(updatedFRPayables);
    } else {
      //console.log('Manual save - Not saving. selectedProductId:', selectedProductId, 'has valid data:', frPayableRows.some(row => row.selectedStates.length > 0 || row.amount));
    }
    
    setSaveChangesModal(true);
    const flattened = flattenColumnData();
    let flattenedSupplements = flattenSupplementData();

    flattenedSupplements = flattenedSupplements.filter(supp => supp.price !== '');

    // Add FR Additional Payables data to products
    //console.log('All stored FR payables:', updatedFRPayables);
    //console.log('Valid product IDs:', Array.from(validProductIds));
    
    const productsWithFRPayables = flattened
      .filter(product => validProductIds.has(product.productId))
      .map(product => {
        // Get FR payables for each product from stored data
        let frPayables = undefined;
        
        // Check if this product has stored FR payables
        const productPayables = updatedFRPayables[product.productId];
        //console.log(`Product ${product.productId} payables:`, productPayables);
        
        if (productPayables) {
          const validFRPayables = productPayables
            .filter(row => row.selectedStates.length > 0 && row.amount)
            .map(row => {
              const stateIds = row.selectedStates.map(stateId => parseInt(stateId));
              const stateAbbrs = row.selectedStates.map(stateId => {
                const state = stateOptions.find(s => s.value === stateId);
                return state ? (state.abv || state.abbreviation || state.code || state.abbrev || state.label) : stateId;
              });
              const amount = parseFloat(row.amount) || 0;
              
              return {
                productId: product.productId,
                stateIds: stateIds,           // Array of state IDs for backend
                stateAbbrs: stateAbbrs,       // Array of abbreviations for display
                payableAmount: amount
              };
            });
          
          frPayables = validFRPayables.length > 0 ? validFRPayables : undefined;
          //console.log(`Product ${product.productId} final FR payables:`, frPayables);
        }

        return {
          ...normalizePriceOverrideProductForApi(product),
          frAdditionalPayables: frPayables,
        };
      })
      .sort((a, b) => a.productCode.localeCompare(b.productCode));

    const vm = clientSingleSelectEnabled
      ? {
          clientIds: [selectedClient.value],
          validProducts: productsWithFRPayables,
          validSupplements: flattenedSupplements.filter(supp => validFormHeaderIds.has(supp.formHeaderId)),
        }
      : {
          clientIds: selectedClients.map(client => client.value),
          validProducts: productsWithFRPayables,
          validSupplements: flattenedSupplements.filter(supp => validFormHeaderIds.has(supp.formHeaderId)),
        };
    setChanges(vm);
  };

  /**
   * FUNCTIONS
   */
  const createSupplementData = (overrides = []) => {
    const validIds = overrides.map(supp => supp.formHeaderId);
    const formattedSupplementData = supplements.reduce((acc, cur) => {
      if (!acc[cur.propertyTypeId]) acc[cur.propertyTypeId] = {};

      if (!acc[cur.propertyTypeId][cur.supplementName]) acc[cur.propertyTypeId][cur.supplementName] = [];

      acc[cur.propertyTypeId][cur.supplementName].push(
        clientSingleSelectEnabled
          ? {
              ...cur,
              ...overrides.find(({ formHeaderId }) => formHeaderId === cur.formHeaderId),
            }
          : cur,
      );
      return acc;
    }, {});

    setSupplementData(formattedSupplementData);
    setFilteredCategorySupplementData(formattedSupplementData);
    setFilteredSupplementData(formattedSupplementData);
    setValidFormHeaderIds(new Set(validIds));
  };

  const createColumnData = (overrides = []) => {
    const validIds = overrides.map(product => product.productId);
    // generate column data
    const formattedColumnData = products.reduce((acc, cur) => {
      if (!acc[cur.propertyTypeName]) acc[cur.propertyTypeName] = {};

      if (!acc[cur.propertyTypeName][cur.productCategoryName]) acc[cur.propertyTypeName][cur.productCategoryName] = [];

      acc[cur.propertyTypeName][cur.productCategoryName].push(
        clientSingleSelectEnabled
          ? normalizePriceOverrideProductForApi({
              ...cur,
              ...overrides.find(({ productId }) => productId === cur.productId),
            })
          : cur,
      );

      return acc;
    }, {});
    setColumnData(formattedColumnData);
    setFilteredCategoryColumnData(formattedColumnData);
    setFilteredNameColumnData(formattedColumnData);
    setValidProductIds(new Set(validIds));

    // Process FR payables from backend response
    const frPayablesFromBackend = {};
    overrides.forEach(product => {
      if (product.frAdditionalPayables && product.frAdditionalPayables.length > 0) {
        // Transform backend FR payables to frontend format
        const frontendPayables = product.frAdditionalPayables.map((payable, index) => ({
          id: index + 1,
          selectedStates: payable.stateIds || [], // Backend sends stateIds array
          dropdownOpen: false,
          amount: payable.payableAmount?.toString() || ''
        }));
        frPayablesFromBackend[product.productId] = frontendPayables;
      }
    });
    
    // Update the FR payables state with data from backend
    setAllProductFRPayables(frPayablesFromBackend);
  };

  const flattenSupplementData = () => {
    const flattened = Object.keys(supplementData)
      .map(propertyTypeName => {
        return Object.keys(supplementData[propertyTypeName]).map(
          supplementName => supplementData[propertyTypeName][supplementName],
        );
      })
      .flat()
      .flat();

    return flattened;
  };

  const flattenColumnData = () => {
    const flattened = Object.keys(columnData)
      .map(propertyTypeName => {
        return Object.keys(columnData[propertyTypeName]).map(
          productCategoryName => columnData[propertyTypeName][productCategoryName],
        );
      })
      .flat()
      .flat();

    return flattened;
  };

  const resetColumnSelections = () => {
    setSelectedPropertyTypeId(null);
    setSelectedProductCategoryId(null);
    setSelectedProductId(null);

    // reset the modified answer weights to track this section
    setValidProductIds(new Set());
  };

  const toggleClientSingleSelectEnabled = evt => {
    const newStatus = evt.target.checked;

    if (newStatus) {
      setSelectedClient(selectedClients[0]);
      setSelectedClients([]);
    } else {
      setSelectedClient(null);
      setSelectedClients([selectedClient]);

      setSelectProduct(newStatus);
      SetwipeUpdateCreate(true);
    }

    resetColumnSelections();

    setClientSingleSelectEnabled(newStatus);
  };

  const toggleSelectProductEnabled = evt => {
    const newStatus = evt.target.checked;

    setSelectProduct(newStatus);
    setSelectedProductId(null);
    setSelectedProductCategoryId(null);
    setSelectedSupplementName(null);
    setSelectedPropertyTypeId(null);
  };

  const toggleSupplementView = evt => {
    const newStatus = evt.target.checked;
    setSupplementView(newStatus);

    setSelectedPropertyTypeId(null);
    setSelectedProductCategoryId(null);
    setSelectedProductId(null);
  };

  const addSupplementToModifiedList = formHeaderId => {
    setValidFormHeaderIds(validFormHeaderIds.add(selectedFormHeaderId));
  };

  const addProductToModifiedList = productId => {
    setValidProductIds(validProductIds.add(productId));
  };

  const getProductNameIndex = (propertyTypeId, productCategoryId, productId) =>
    columnData[propertyTypeId][productCategoryId].findIndex(cat => cat.productId === productId);

  const getSupplementIndex = (propertyTypeId, supplementNameId, formHeaderId) =>
    supplementData[propertyTypeId][supplementNameId].findIndex(cat => cat.formHeaderId === formHeaderId);

  const handleChangeSupplementOverride = field => evt => {
    const { value } = evt.target;

    const updatedColumnData = JSON.parse(JSON.stringify({ ...supplementData }));
    const supplementNameIndex = getSupplementIndex(
      selectedPropertyTypeId,
      selectedSupplementName,
      selectedFormHeaderId,
    );

    updatedColumnData[selectedPropertyTypeId][selectedSupplementName][supplementNameIndex][field] = value;

    setSupplementData(updatedColumnData);
    setFilteredCategorySupplementData(updatedColumnData);
    setFilteredSupplementData(updatedColumnData);
    addSupplementToModifiedList(selectedFormHeaderId);
  };

  const commitProductOverrideRowUpdate = updatedColumnData => {
    const productNameIndex = getProductNameIndex(
      selectedPropertyTypeId,
      selectedProductCategoryId,
      selectedProductId,
    );
    const errorSelection = updatedColumnData[selectedPropertyTypeId][selectedProductCategoryId][productNameIndex];

    const tier1_Is_Valid = !!errorSelection.tier1;
    const tier2_Is_Valid = !!errorSelection.tier2;
    const tier3_Is_Valid = !!errorSelection.tier3;

    // first happy path : all values are filled in
    if (tier1_Is_Valid && tier2_Is_Valid && tier3_Is_Valid) {
      let catError = false;
      let typError = false;
      const ind = errorName.findIndex(x => x == selectedProductId);
      if (ind >= 0) {
        errorName.splice(ind, 1);
      }
      Object.entries(columnData[selectedPropertyTypeId][selectedProductCategoryId]).forEach(([key, value]) => {
        const { productId } = value;
        // allows the foreach loop to evaluate every instance of the categorie's prooduct IDs in the error Name list.
        // Returns true if it finds one.
        if (errorName.includes(productId.toString())) {
          catError = true;
        }
      });

      //default behavior if the error array contains no members of the sub to the Type.
      // meaning no instance of a sub- product ID was found
      if (catError == false) {
        const ind = errorCategory.findIndex(x => x == selectedProductCategoryId);
        if (ind >= 0) {
          errorCategory.splice(ind, 1);
        }
      }

      Object.entries(columnData[selectedPropertyTypeId]).forEach(([key, value]) => {
        if (errorCategory.includes(key)) {
          typError = true;
        }
      });
      if (typError == false) {
        const ind = errorType.findIndex(x => x == selectedPropertyTypeId);
        if (ind >= 0) {
          errorType.splice(ind, 1);
        }
      }

      if (!validProductIds.has(selectedProductId)) {
        validProductIds.add(selectedProductId);
      }

      //Update Column Data
      setColumnData(updatedColumnData);
      setFilteredCategoryColumnData(updatedColumnData);
      setFilteredNameColumnData(updatedColumnData);
      addProductToModifiedList(selectedProductId);

      //Validate Data and add Errors
      setErrorType(errorType);
      setErrorCategory(errorCategory);
      setErrorName(errorName);
      return;
    }
    // second happy path : no values are filled in
    if (!tier1_Is_Valid && !tier2_Is_Valid && !tier3_Is_Valid) {
      let catError = false;
      let typError = false;
      const ind = errorName.findIndex(x => x == selectedProductId);

      if (ind >= 0) {
        errorName.splice(ind, 1);
      }
      Object.entries(columnData[selectedPropertyTypeId][selectedProductCategoryId]).forEach(([key, value]) => {
        const { productId } = value;
        // allows the foreach loop to evaluate every instance of the categorie's prooduct IDs in the error Name list.
        // Returns true if it finds one.
        if (errorName.includes(productId.toString())) {
          catError = true;
        }
      });

      //default behavior if the error array contains no members of the sub to the Type.
      // meaning no instance of a sub- product ID was found
      if (catError == false) {
        const ind = errorCategory.findIndex(x => x == selectedProductCategoryId);
        if (ind >= 0) {
          errorCategory.splice(ind, 1);
        }
      }

      Object.entries(columnData[selectedPropertyTypeId]).forEach(([key, value]) => {
        if (errorCategory.includes(key)) {
          typError = true;
        }
      });
      if (typError == false) {
        const ind = errorType.findIndex(x => x == selectedPropertyTypeId);
        if (ind >= 0) {
          errorType.splice(ind, 1);
        }
      }

      if (!validProductIds.has(selectedProductId)) {
        validProductIds.add(selectedProductId);
      }

      //Update Column Data
      setColumnData(updatedColumnData);
      setFilteredCategoryColumnData(updatedColumnData);
      setFilteredNameColumnData(updatedColumnData);
      addProductToModifiedList(selectedProductId);

      //Validate Data and add Errors
      setErrorType(errorType);
      setErrorCategory(errorCategory);
      setErrorName(errorName);
      return;
    }
    if (!tier1_Is_Valid || !tier2_Is_Valid || !tier3_Is_Valid) {
      if (!errorType.includes(selectedPropertyTypeId.toString())) {
        errorType.push(selectedPropertyTypeId.toString());
      }
      if (!errorCategory.includes(selectedProductCategoryId.toString())) {
        errorCategory.push(selectedProductCategoryId.toString());
      }

      if (!errorName.includes(selectedProductId.toString())) {
        errorName.push(selectedProductId.toString());
      }

      if (!validProductIds.has(selectedProductId)) {
        validProductIds.add(selectedProductId);
      }

      //Update Column Data
      setColumnData(updatedColumnData);
      setFilteredCategoryColumnData(updatedColumnData);
      setFilteredNameColumnData(updatedColumnData);
      addProductToModifiedList(selectedProductId);

      //Validate Data and add Errors
      setErrorType(errorType);
      setErrorCategory(errorCategory);
      setErrorName(errorName);
      return;
    }
  };

  const handleChangeProductOverride = field => evt => {
    const { value, type, checked } = evt.target;

    // Handle checkbox values differently
    const fieldValue = type === 'checkbox' ? checked : value;

    const updatedColumnData = JSON.parse(JSON.stringify({ ...columnData }));

    const productNameIndex = getProductNameIndex(
      selectedPropertyTypeId,
      selectedProductCategoryId,
      selectedProductId,
    );

    updatedColumnData[selectedPropertyTypeId][selectedProductCategoryId][productNameIndex][field] = fieldValue;

    commitProductOverrideRowUpdate(updatedColumnData);
  };

  const applyIqOwnerRejectChoice = choice => {
    const updatedColumnData = JSON.parse(JSON.stringify({ ...columnData }));
    const productNameIndex = getProductNameIndex(
      selectedPropertyTypeId,
      selectedProductCategoryId,
      selectedProductId,
    );
    const row = updatedColumnData[selectedPropertyTypeId][selectedProductCategoryId][productNameIndex];
    row.cancelQVOnHOReject = choice === 'cancel';
    row.convertToVirtualOnReject = choice === 'virtual';
    row.convertProduct = choice === 'convertProduct';
    if (choice !== 'convertProduct') {
      row.convertToProductId = '';
    }
    commitProductOverrideRowUpdate(updatedColumnData);
  };

  const handleIqOwnerRejectCheckboxChange = choice => evt => {
    applyIqOwnerRejectChoice(evt.target.checked ? choice : null);
  };

  const setupSupplementState = async () => {
    if (selectedClient) {
      const supplementOverrides = await getSuppOverridesByClientIdAsync(selectedClient.value);
      createSupplementData(supplementOverrides);
    } else {
      createSupplementData();
    }
  };

  const setupInitialClientState = async () => {
    // clear questions and answer weight columns
    resetColumnSelections();

    if (selectedClient) {
      // fetch questions for this form header
      const overrides = await getPriceOverridesByClientIdAsync(selectedClient.value);
      //console.log(overrides)
      createColumnData(overrides);
    } else {
      createColumnData();
    }
  };

  const handleSupplementNameInputChange = formHeaderId => evt => {
    const value = evt.target;
    if (validFormHeaderIds.has(formHeaderId)) {
      validFormHeaderIds.delete(formHeaderId);

      const { propertyTypeId, supplementName } = supplements.find(supp => supp.formHeaderId === formHeaderId);
      const supplementNameIndex = getSupplementIndex(propertyTypeId, supplementName, formHeaderId);

      const updatedSupplementData = JSON.parse(JSON.stringify({ ...supplementData }));

      updatedSupplementData[propertyTypeId][supplementNameIndex] = {
        ...updatedSupplementData[propertyTypeId][supplementNameIndex],
        price: '',
      };

      setSupplementData(updatedSupplementData);
      setFilteredCategorySupplementData(updatedSupplementData);
      setFilteredSupplementData(updatedSupplementData);
    } else {
      validFormHeaderIds.add(formHeaderId);
    }
    if (value.value === '') {
      validFormHeaderIds.delete(formHeaderId);
    }
  };

  const handleProductNameCheckboxChange = productId => evt => {
    // toggle checked status
    if (validProductIds.has(productId)) {
      validProductIds.delete(productId);

      const { propertyTypeName, productCategoryName } = products.find(product => product.productId === productId);
      const productNameIndex = getProductNameIndex(propertyTypeName, productCategoryName, productId);

      const updatedColumnData = JSON.parse(JSON.stringify({ ...columnData }));

      updatedColumnData[propertyTypeName][productCategoryName][productNameIndex] = {
        ...updatedColumnData[propertyTypeName][productCategoryName][productNameIndex],
        tier1: '',
        tier2: '',
        tier3: '',
      };

      setColumnData(updatedColumnData);
      setFilteredCategoryColumnData(updatedColumnData);
      setFilteredNameColumnData(updatedColumnData);
    } else {
      validProductIds.add(productId);
    }
    //console.log(evt.target.checked);
  };

  /**
   * FUNCTIONS: RENDERING
   */
  const renderCell = ({
    title,
    subtitle,
    isSelected,
    isError = false,
    count = null,
    columnDisabled,
    key,
    onClick,
    showCheckbox = false,
    checked,
    onCheckboxClick,
  }) => {
    return (
      <div
        key={key}
        className={cn(
          classes.columnTile,
          isSelected && classes.columnTileSelected,
          columnDisabled && classes.columnDisabled,
        )}
        onClick={onClick}
      >
        <div className={cn('row-between-center')}>
          {showCheckbox && (
            <ColoredCheckbox
              //
              style={{ marginRight: 15 }}
              checked={checked}
              onClick={onCheckboxClick}
            />
          )}

          <section className={cn('col-center-start text-left')}>
            <div>{title}</div>
            {subtitle && <div style={{ fontSize: '0.8em', color: isSelected ? null : '#AAA' }}>{subtitle}</div>}
          </section>
        </div>

        <div>
          {isError == true && <Error style={{ color: 'red' }} />}
          <ChevronRight />
        </div>
      </div>
    );
  };

  const renderSupplementNameCell = (name, index) => {
    const isSelected = name === selectedSupplementName;
    const columnDisabled = !formIsReady;

    const onClick = () => {
      setSelectedSupplementName(name);
      setSelectedFormHeaderId(supplementData[selectedPropertyTypeId][name][0].formHeaderId);
    };

    return renderCell({
      title: name,
      columnDisabled,
      isSelected,
      key: `Supplement-type-${name}`,
      onClick,
    });
  };

  const renderPropertyTypeCell = (name, index) => {
    /** supplements don't have a propertytypename column so map the id to the corresponding name */
    let typeName = name;

    if (supplementView) {
      if (name === 1) {
        typeName = 'Residential';
      } else if (name === 2) {
        typeName = 'Commercial';
      }
    }

    const isSelected = typeName === selectedPropertyTypeId;
    const columnDisabled = !formIsReady;

    const onClick = () => {
      setSelectedProductId(null);
      setSelectedProductCategoryId(null);
      setSelectedPropertyTypeId(name);

      // for supplements
      setSelectedFormHeaderId(null);
      setSelectedSupplementName(null);
    };

    return renderCell({
      title: typeName,
      isSelected,
      isError: errorType.includes(name),
      columnDisabled,
      key: `property-type-${name}`,
      onClick,
    });
  };

  const renderProductCategoryCell = (name, index) => {
    const isSelected = name === selectedProductCategoryId;
    const columnDisabled = !formIsReady;

    const onClick = () => {
      setSelectedProductId(null);
      setSelectedProductCategoryId(name);
    };

    return renderCell({
      title: name,
      isError: errorCategory.includes(name),
      isSelected,
      columnDisabled,
      key: `product-category-${selectedPropertyTypeId}-${name}`,
      onClick,
    });
  };

  const runSupplementFilter = event => {
    const suppFilter = document?.getElementById('suppNameFilter').value.toUpperCase() ?? '';

    const returnedData = Object.entries(supplementData)
      ?.map(([TypeKey, TypeValue]) => {
        TypeValue = Object.entries(TypeValue)
          ?.filter(([CategoryKey, CategoryValue]) => {
            //console.log(key);
            return CategoryKey?.toUpperCase()?.includes(suppFilter);
          })
          ?.reduce((accCategory, [CategoryKey, CategoryValue]) => {
            accCategory[CategoryKey] = CategoryValue;
            return accCategory;
          }, {});
        return [TypeKey, TypeValue];
      })
      ?.reduce((accType, [TypeKey, TypeValue]) => {
        accType[TypeKey] = TypeValue;
        return accType;
      }, {});
    setFilteredCategorySupplementData(returnedData);
  };

  const runCategoriesFilter = event => {
    const prodNameFilter = document?.getElementById('productNameFilter').value.toUpperCase() ?? '';
    const prodCategoriesFilter = document?.getElementById('productCategoriesFilter').value.toUpperCase() ?? '';

    const returnedData = Object.entries(columnData)
      ?.map(([TypeKey, TypeValue]) => {
        TypeValue = Object.entries(TypeValue)
          ?.filter(([CategoryKey, CategoryValue]) => {
            //console.log(key);
            return CategoryKey?.toUpperCase()?.includes(prodCategoriesFilter);
          })
          ?.reduce((accCategory, [CategoryKey, CategoryValue]) => {
            accCategory[CategoryKey] = CategoryValue;
            return accCategory;
          }, {});
        return [TypeKey, TypeValue];
      })
      ?.reduce((accType, [TypeKey, TypeValue]) => {
        accType[TypeKey] = TypeValue;
        return accType;
      }, {});
    setFilteredCategoryColumnData(returnedData);
  };

  const runNameFilter = event => {
    const prodNameFilter = document?.getElementById('productNameFilter').value.toUpperCase() ?? '';

    const returnedData = Object.entries(columnData)
      ?.map(([TypeKey, TypeValue]) => {
        TypeValue = Object.entries(TypeValue)
          ?.map(([CategoryKey, CategoryValue]) => {
            CategoryValue = Object.entries(CategoryValue)
              ?.filter(([NameKey, NameValue]) => {
                const { productCode } = NameValue;
                return productCode?.toUpperCase()?.includes(prodNameFilter);
              })
              ?.reduce((accName, [NameKey, NameValue]) => {
                accName.push(NameValue);
                return accName;
              }, []);
            return [CategoryKey, CategoryValue];
          })
          ?.reduce((accCategory, [CategoryKey, CategoryValue]) => {
            accCategory[CategoryKey] = CategoryValue;
            return accCategory;
          }, {});
        return [TypeKey, TypeValue];
      })
      ?.reduce((accType, [TypeKey, TypeValue]) => {
        accType[TypeKey] = TypeValue;
        return accType;
      }, {});
    setFilteredNameColumnData(returnedData);
  };

  const renderProductNameCell = (product, index) => {
    const { productId, productName, productCode } = product;

    const isSelected = productId === selectedProductId;
    const columnDisabled = !formIsReady;

    const onClick = () => {
      // Save current FR payables before switching products
      //console.log('Switching products - current selectedProductId:', selectedProductId);
      //console.log('Current frPayableRows:', frPayableRows);
      
      if (selectedProductId && frPayableRows.some(row => row.selectedStates.length > 0 || row.amount)) {
        //console.log('Saving FR payables for product:', selectedProductId);
        setAllProductFRPayables(prev => {
          const updated = {
            ...prev,
            [selectedProductId]: [...frPayableRows]
          };
          //console.log('Updated allProductFRPayables:', updated);
          
          // Add this product to validProductIds if it has FR payables data
          if (!validProductIds.has(selectedProductId)) {
            //console.log('Adding FR payables product to valid products during switch:', selectedProductId);
            validProductIds.add(selectedProductId);
            setValidProductIds(new Set(validProductIds));
          }
          
          return updated;
        });
      } else {
        //console.log('Not saving - selectedProductId:', selectedProductId, 'has valid data:', frPayableRows.some(row => row.selectedStates.length > 0 || row.amount));
      }
      
      setSelectedProductId(productId);
    };

    const isCheckboxChecked = validProductIds.has(product.productId);

    return renderCell({
      title: productCode,
      subtitle: productName,
      isError: errorName.includes(productId.toString()),
      isSelected,
      columnDisabled,
      key: `product-${selectedPropertyTypeId}-${selectedProductCategoryId}-${productId}`,
      onClick,
      showCheckbox: true,
      checked: isCheckboxChecked,
      onCheckboxClick: handleProductNameCheckboxChange(product.productId),
    });
  };

  const renderPriceOverrides = () => {
    const columnDisabled = !formIsReady;

    return (
      <div style={{ marginBottom: 25, padding: '15px', borderRadius: '6px' }}>
        <div style={{ 
          fontWeight: '600', 
          marginBottom: 15, 
          fontSize: '14px', 
          color: '#495057',
          borderBottom: '1px solid #dee2e6',
          paddingBottom: '8px'
        }}>
          Price Overrides
        </div>
        {priceOverrideInputs.map(({ field, label, type = 'number' }, index) => {
          const value = columnData[selectedPropertyTypeId][selectedProductCategoryId].find(
            cat => cat.productId === selectedProductId,
          )?.[field];

          return (
            <div key={`product-${selectedProductId}-${field}`}>
              {index > 0 && (
                <div style={{ 
                  borderBottom: '1px solid #dee2e6', 
                  marginBottom: 8 
                }} />
              )}
              <div
                className={cn('row-between-center', columnDisabled && classes.columnDisabled)}
                style={{ marginBottom: 8 }}
              >
                <div className={'text-left'} style={{ minWidth: 80, fontSize: '13px', color: '#6c757d' }}>{label}</div>
                <input
                  type={type}
                  min={type === 'number' ? '0' : undefined}
                  value={value || ''}
                  className={cn(classes.input, classes.textInput)}
                  style={{ 
                    width: 160, 
                    marginLeft: 10, 
                    padding: '6px 8px',
                    fontSize: '13px',
                    border: '1px solid #ced4da',
                    borderRadius: '4px'
                  }}
                  onChange={handleChangeProductOverride(field)}
                  disabled={columnDisabled}
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const renderFRAdditionalPayables = () => {
    const columnDisabled = !formIsReady;

    const renderPayableRow = (row, index) => {
      const selectedStateLabels = row.selectedStates.length > 0 
        ? row.selectedStates.length === 1 
          ? stateOptions.find(s => s.value === row.selectedStates[0])?.label || 'Unknown'
          : `${row.selectedStates.length} states selected`
        : 'Select states';

      return (
        <div key={row.id} style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
          <div style={{ flex: 1, minWidth: '140px', marginRight: 10, position: 'relative' }} data-state-dropdown>
            <div
              style={{
                padding: '6px 10px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                backgroundColor: columnDisabled ? '#f5f5f5' : 'white',
                cursor: columnDisabled ? 'not-allowed' : 'pointer',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                minHeight: '32px',
                height: '32px',
                boxSizing: 'border-box'
              }}
              onClick={() => !columnDisabled && handleRowDropdownToggle(row.id)}
            >
              <span style={{ color: row.selectedStates.length === 0 ? '#999' : '#333' }}>
                {selectedStateLabels}
              </span>
              <span style={{ fontSize: '12px' }}>▼</span>
            </div>
            
            {row.dropdownOpen && !columnDisabled && (
              <div 
                className="dropdown-list"
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  backgroundColor: 'white',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                  zIndex: 1000,
                  maxHeight: '200px',
                  overflowY: 'auto'
                }}>
                {/* Select All Option */}
                <div
                  style={{
                    padding: '6px 10px',
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    fontSize: '13px',
                    fontWeight: 'bold',
                    borderBottom: '2px solid #dee2e6',
                    backgroundColor: '#f8f9fa'
                  }}
                  onClick={() => {
                    // Get the dropdown element and current scroll position
                    const dropdownElement = document.querySelector('[data-state-dropdown] .dropdown-list');
                    const currentScrollTop = dropdownElement?.scrollTop || 0;
                    
                    const allSelected = row.selectedStates.length === stateOptions.length;
                    const newStates = allSelected ? [] : stateOptions.map(state => state.value);
                    setFrPayableRows(prev => {
                      const updatedRows = prev.map(r => 
                        r.id === row.id ? { ...r, selectedStates: newStates } : r
                      );
                      
                      // Use setTimeout to restore scroll position after React re-renders
                      setTimeout(() => {
                        if (dropdownElement) {
                          dropdownElement.scrollTop = currentScrollTop;
                        }
                      }, 0);
                      
                      // Immediately save to allProductFRPayables if we have a selected product
                      if (selectedProductId) {
                        setAllProductFRPayables(prevAll => ({
                          ...prevAll,
                          [selectedProductId]: [...updatedRows]
                        }));
                        
                        // Add to valid products if it has data
                        if (newStates.length > 0 && !validProductIds.has(selectedProductId)) {
                          validProductIds.add(selectedProductId);
                          setValidProductIds(new Set(validProductIds));
                        }
                      }
                      
                      return updatedRows;
                    });
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', marginRight: 8, cursor: 'pointer' }}>
                    <ColoredCheckbox
                      checked={row.selectedStates.length === stateOptions.length}
                      indeterminate={row.selectedStates.length > 0 && row.selectedStates.length < stateOptions.length}
                      onChange={() => {}} // Prevent default onChange
                      style={{ 
                        padding: 0, 
                        pointerEvents: 'none',
                        color: envTheme.colors.primary,
                        '&.Mui-checked': {
                          color: envTheme.colors.primary,
                        },
                        '&.MuiCheckbox-indeterminate': {
                          color: envTheme.colors.primary,
                        }
                      }}
                    />
                  </div>
                  Select All
                </div>
                
                {stateOptions
                  .sort((a, b) => {
                    const aSelected = row.selectedStates.includes(a.value);
                    const bSelected = row.selectedStates.includes(b.value);
                    
                    // If one is selected and the other isn't, selected goes first
                    if (aSelected && !bSelected) return -1;
                    if (!aSelected && bSelected) return 1;
                    
                    // If both are selected or both are not selected, sort alphabetically
                    return a.label.localeCompare(b.label);
                  })
                  .map(state => (
                    <div
                      key={state.value}
                      style={{
                        padding: '6px 10px',
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        fontSize: '13px',
                        borderBottom: '1px solid #f0f0f0',
                        backgroundColor: row.selectedStates.includes(state.value) ? '#f0f8ff' : 'transparent'
                      }}
                      onClick={() => handleRowStateSelection(row.id, state.value)}
                    >
                      <div 
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRowStateSelection(row.id, state.value);
                        }}
                        style={{ display: 'flex', alignItems: 'center', marginRight: 8, cursor: 'pointer' }}
                      >
                        <ColoredCheckbox
                          checked={row.selectedStates.includes(state.value)}
                          onChange={() => {}} // Prevent default onChange
                          style={{ 
                            padding: 0, 
                            pointerEvents: 'none',
                            color: envTheme.colors.primary,
                            '&.Mui-checked': {
                              color: envTheme.colors.primary,
                            },
                            '&.MuiCheckbox-indeterminate': {
                              color: envTheme.colors.primary,
                            }
                          }}
                        />
                      </div>
                      {state.label}
                    </div>
                  ))}
              </div>
            )}
          </div>
          <input
            type="number"
            min="0"
            step="0.01"
            placeholder="Amount"
            value={row.amount}
            onChange={(e) => handleRowAmountChange(row.id, e.target.value)}
            style={{
              flex: 1,
              minWidth: '100px',
              maxWidth: '150px',
              padding: '6px 10px',
              marginRight: 10,
              border: '1px solid #ccc',
              borderRadius: '4px',
              fontSize: '13px',
              minHeight: '32px',
              boxSizing: 'border-box',
              height: '32px'
            }}
            disabled={columnDisabled}
          />
          {frPayableRows.length > 1 && (
            <DeleteIcon
              fontSize={'small'}
              className={cn('list-action-icon')}
              style={{
                color: 'red',
                cursor: columnDisabled ? 'not-allowed' : 'pointer',
                opacity: columnDisabled ? 0.5 : 1
              }}
              onClick={columnDisabled ? undefined : () => handleRemoveFRPayableRow(row.id)}
              title="Remove FR Additional Payable"
            />
          )}
        </div>
      );
    };

    return (
      <div style={{ marginBottom: 25, padding: '15px', borderRadius: '6px' }}>
        <div style={{ 
          fontWeight: '600', 
          marginBottom: 15, 
          fontSize: '14px', 
          color: '#495057',
          borderBottom: '1px solid #dee2e6',
          paddingBottom: '8px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <span>FR Additional Payable</span>
          <AddCircleIcon
            fontSize={'small'}
            style={{
              color: 'green',
              cursor: columnDisabled ? 'not-allowed' : 'pointer',
              opacity: columnDisabled ? 0.5 : 1
            }}
            onClick={columnDisabled ? undefined : handleAddFRPayableRow}
            title="Add FR Additional Payable"
          />
        </div>
        {frPayableRows.map((row, index) => renderPayableRow(row, index))}
      </div>
    );
  };

  const renderQAAdditionalPayable = () => {
    const columnDisabled = !formIsReady;
    const value = columnData[selectedPropertyTypeId][selectedProductCategoryId].find(
      cat => cat.productId === selectedProductId,
    )?.qaPayableAmount;

    return (
      <div style={{ marginBottom: 25, padding: '15px', borderRadius: '6px' }}>
        <div style={{ 
          fontWeight: '600', 
          marginBottom: 15, 
          fontSize: '14px', 
          color: '#495057',
          borderBottom: '1px solid #dee2e6',
          paddingBottom: '8px'
        }}>
          QA Additional Payable
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <input
            type="number"
            min="0"
            value={value || ''}
            placeholder="Amount"
            className={cn(classes.input, classes.textInput)}
            style={{ 
              flex: 1,
              padding: '6px 8px',
              fontSize: '13px',
              border: '1px solid #ced4da',
              borderRadius: '4px'
            }}
            onChange={handleChangeProductOverride('qaPayableAmount')}
            disabled={columnDisabled}
          />
        </div>
      </div>
    );
  };

  const renderProductOptions = () => {
    const columnDisabled = !formIsReady;
    const productData = columnData[selectedPropertyTypeId][selectedProductCategoryId].find(
      cat => cat.productId === selectedProductId,
    );
    const iqOptionsDisabled = !productData?.iqProduct;
//  console.log({productData});
    return (
      <div style={{ marginBottom: 25, padding: '15px', borderRadius: '6px' }}>
        <div style={{ 
          fontWeight: '600', 
          marginBottom: 15, 
          fontSize: '14px', 
          color: '#495057',
          borderBottom: '1px solid #dee2e6',
          paddingBottom: '8px'
        }}>
          Product Options
        </div>
        {productOptionsInputs
          .filter(({ field }) => !['dueDateDays', 'scheduleRequired'].includes(field))
          .map(({ field, label, type, dependsOn }, index) => {
            // Handle heading type
            if (type === 'heading') {
              return (
                <div
                  key={`heading-${index}`}
                  style={{
                    fontWeight: '600',
                    fontSize: '13px',
                    color: '#495057',
                    marginTop: index > 0 ? 15 : 0,
                    marginBottom: 10,
                    paddingBottom: 8,
                    borderBottom: '1px solid #dee2e6',
                  }}
                >
                  {label}
                </div>
              );
            }

            if (type === 'iqOwnerRejectRadioGroup') {
              const ownerRejectSelection = getIqOwnerRejectRadioValue(productData);
              const iqRadioRowMuted =
                !columnDisabled && iqOptionsDisabled;
              const checkboxBlock = (
                <FormControl
                  component="fieldset"
                  disabled={columnDisabled || iqOptionsDisabled}
                  style={{ width: '100%', margin: 0, padding: 0 }}
                >
                  <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 6 }}>
                    <FormControlLabel
                      control={
                        <ColoredCheckbox
                          color="default"
                          checked={ownerRejectSelection === 'cancel'}
                          onChange={handleIqOwnerRejectCheckboxChange('cancel')}
                        />
                      }
                      label={
                        <span style={{ fontSize: '13px', color: '#6c757d' }}>Cancel IQ On Owner Reject</span>
                      }
                      labelPlacement="start"
                      style={{
                        margin: 0,
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    />
                    <FormControlLabel
                      control={
                        <ColoredCheckbox
                          color="default"
                          checked={ownerRejectSelection === 'virtual'}
                          onChange={handleIqOwnerRejectCheckboxChange('virtual')}
                        />
                      }
                      label={
                        <span style={{ fontSize: '13px', color: '#6c757d' }}>
                          Convert To Virtual On Owner Reject
                        </span>
                      }
                      labelPlacement="start"
                      style={{
                        margin: 0,
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    />
                    <FormControlLabel
                      control={
                        <ColoredCheckbox
                          color="default"
                          checked={ownerRejectSelection === 'convertProduct'}
                          onChange={handleIqOwnerRejectCheckboxChange('convertProduct')}
                        />
                      }
                      label={
                        <span style={{ fontSize: '13px', color: '#6c757d' }}>
                          Convert Product on Owner Reject
                        </span>
                      }
                      labelPlacement="start"
                      style={{
                        margin: 0,
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    />
                  </div>
                </FormControl>
              );
              return (
                <div
                  className={cn(
                    columnDisabled && classes.columnDisabled,
                    iqRadioRowMuted && classes.columnMutedNoPointerBlock,
                  )}
                  style={{ marginBottom: 8, width: '100%' }}
                  key={`product-option-${selectedProductId}-iq-owner-reject`}
                >
                  {iqOptionsDisabled ? (
                    <Tooltip title={IQ_OPTIONS_ONLY_TOOLTIP} arrow>
                      <span style={{ display: 'block', width: '100%' }}>{checkboxBlock}</span>
                    </Tooltip>
                  ) : (
                    checkboxBlock
                  )}
                </div>
              );
            }

            const value = productData?.[field];

            if (field === 'convertToProductId') {
              if (getIqOwnerRejectRadioValue(productData) !== 'convertProduct') {
                return null;
              }
            } else if (dependsOn && !productData?.[dependsOn]) {
              return null;
            }

          const renderInput = () => {
            if (type === 'checkbox') {
              // Call ahead: all IQ products, or virtual products with propertyTypeId 2
              const shouldDisableCallAhead =
                field === 'callAhead' &&
                (productData?.iqProduct || (productData?.virtualProduct && productData?.propertyTypeId === 2));
              // Phone interview: only IQ products with propertyTypeId 2
              const shouldDisablePhoneInterview =
                field === 'phoneInterview' && productData?.iqProduct && productData?.propertyTypeId === 2;
              const shouldDisableCallAheadOrPhoneInterview =
                shouldDisableCallAhead || shouldDisablePhoneInterview;

              // For IQ products with propertyTypeId 2, phoneInterview should be forced on and show tooltip
              const isIQProductRequiringInterview = field === 'phoneInterview' && productData?.iqProduct && productData?.propertyTypeId === 2;
              const checkboxChecked = isIQProductRequiringInterview ? true : Boolean(value);
              
              const checkbox = (
                <ColoredCheckbox
                  checked={checkboxChecked}
                  onChange={handleChangeProductOverride(field)}
                  disabled={
                    columnDisabled ||
                    shouldDisableCallAheadOrPhoneInterview ||
                    (IQ_OPTION_FIELDS.has(field) && iqOptionsDisabled)
                  }
                />
              );
              
              // Wrap in tooltip if this is an IQ product requiring interview
              if (isIQProductRequiringInterview) {
                return (
                  <Tooltip title="This product code requires an interview" arrow>
                    <span>{checkbox}</span>
                  </Tooltip>
                );
              }

              if (field === 'callAhead' && shouldDisableCallAhead && productData?.iqProduct) {
                return (
                  <Tooltip title="Not valid for IQ Products" arrow>
                    <span style={{ display: 'inline-flex' }}>{checkbox}</span>
                  </Tooltip>
                );
              }

              if (IQ_OPTION_FIELDS.has(field) && iqOptionsDisabled) {
                return (
                  <Tooltip title={IQ_OPTIONS_ONLY_TOOLTIP} arrow>
                    <span style={{ display: 'inline-flex' }}>{checkbox}</span>
                  </Tooltip>
                );
              }

              return checkbox;
            } else if (type === 'dropdown' && field === 'convertToProductId') {
              const propertyTypeName = productData?.propertyTypeName;
              let convertOptions = products
                .filter(
                  p =>
                    propertyTypeName &&
                    p.propertyTypeName === propertyTypeName &&
                    p.productId !== selectedProductId &&
                    (!clientSingleSelectEnabled || validProductIds.has(p.productId)) &&
                    !p.iqProduct,
                )
                .map(p => ({
                  value: p.productId,
                  label: `${p.productCode} - ${p.productName}`,
                  productCode: p.productCode,
                  productName: p.productName,
                }))
                .sort((a, b) =>
                  a.label.localeCompare(b.label, undefined, { sensitivity: 'base', numeric: true }),
                );

              const currentConvertId = value;
              if (
                currentConvertId != null &&
                currentConvertId !== '' &&
                !convertOptions.some(o => o.value === currentConvertId || o.value == currentConvertId)
              ) {
                const p = products.find(pr => pr.productId == currentConvertId);
                if (p && !p.iqProduct) {
                  convertOptions = [
                    ...convertOptions,
                    {
                      value: p.productId,
                      label: `${p.productCode} - ${p.productName}`,
                      productCode: p.productCode,
                      productName: p.productName,
                    },
                  ].sort((a, b) =>
                    a.label.localeCompare(b.label, undefined, { sensitivity: 'base', numeric: true }),
                  );
                }
              }

              const selectedConvertOption =
                currentConvertId != null && currentConvertId !== ''
                  ? convertOptions.find(o => o.value == currentConvertId) ?? null
                  : null;

              const convertAutocomplete = (
                <Autocomplete
                  isClearable
                  isAbsolute
                  placeholder="Search Product"
                  options={convertOptions}
                  value={selectedConvertOption}
                  formatOptionLabel={(option, { context }) => {
                    if (!option) return '';
                    if (context === 'value') {
                      return option.productCode ?? '';
                    }
                    return (
                      <span style={{ whiteSpace: 'nowrap' }}>
                        {option.productCode} - {option.productName}
                      </span>
                    );
                  }}
                  onChange={opt =>
                    handleChangeProductOverride(field)({
                      target: { value: opt == null ? '' : opt.value, type: 'text' },
                    })
                  }
                  disabled={columnDisabled || iqOptionsDisabled}
                  loading={productsLoading}
                  containerStyles={{ zIndex: 2 }}
                  controlStyles={{ minHeight: 36, fontSize: '13px' }}
                  styleOptions={{
                    menu: base => ({
                      ...base,
                      left: 'auto',
                      right: 0,
                      width: 'max-content',
                      minWidth: '100%',
                    }),
                    option: base => ({
                      ...base,
                      whiteSpace: 'nowrap',
                    }),
                  }}
                  extraProps={{ menuPlacement: 'auto' }}
                />
              );

              return iqOptionsDisabled ? (
                <Tooltip title={IQ_OPTIONS_ONLY_TOOLTIP} arrow>
                  <span
                    style={{
                      display: 'block',
                      flex: 1,
                      minWidth: 160,
                      marginLeft: 10,
                      maxWidth: '100%',
                    }}
                  >
                    {convertAutocomplete}
                  </span>
                </Tooltip>
              ) : (
                <div style={{ flex: 1, minWidth: 160, marginLeft: 10 }}>{convertAutocomplete}</div>
              );
            } else {
              const textInput = (
                <input
                  type={type}
                  min={type === 'number' ? '0' : undefined}
                  value={value || ''}
                  className={cn(classes.input, classes.textInput)}
                  style={{ 
                    width: type === 'text' ? 150 : 80, 
                    marginLeft: 10,
                    padding: '6px 8px',
                    fontSize: '13px',
                    border: '1px solid #ced4da',
                    borderRadius: '4px'
                  }}
                  onChange={handleChangeProductOverride(field)}
                  disabled={columnDisabled || (IQ_OPTION_FIELDS.has(field) && iqOptionsDisabled)}
                />
              );

              if (IQ_OPTION_FIELDS.has(field) && iqOptionsDisabled) {
                return (
                  <Tooltip title={IQ_OPTIONS_ONLY_TOOLTIP} arrow>
                    <span style={{ display: 'inline-block' }}>{textInput}</span>
                  </Tooltip>
                );
              }

              return textInput;
            }
          };

          const iqRowMutedOnly =
            !columnDisabled && field && IQ_OPTION_FIELDS.has(field) && iqOptionsDisabled;

          return (
            <div
              className={cn(
                'row-between-center',
                columnDisabled && classes.columnDisabled,
                iqRowMutedOnly && classes.columnMutedNoPointerBlock,
              )}
              style={{ marginBottom: 8 }}
              key={`product-option-${selectedProductId}-${field}`}
            >
              <div className={'flex-1 text-left'} style={{ fontSize: '13px', color: '#6c757d' }}>{label}</div>
              {renderInput()}
            </div>
          );
        })}
      </div>
    );
  };

  const renderProductConfiguration = () => {
    return (
      <div>
        {renderPriceOverrides()}
        {renderFRAdditionalPayables()}
        {renderQAAdditionalPayable()}
        {renderProductOptions()}
      </div>
    );
  };

  const renderSupplementOverridesColumn = () => {
    const columnDisabled = !formIsReady;
    return supplementFormInput.map(({ field, label }) => {
      const value = supplementData[selectedPropertyTypeId][selectedSupplementName]?.find(
        cat => cat.formHeaderId === selectedFormHeaderId,
      )?.[field];

      return (
        <div
          className={cn('row-between-center', columnDisabled && classes.columnDisabled)}
          style={{ borderBottom: '1px solid #AAA', paddingBottom: 10, marginBottom: 10 }}
          key={`product-${selectedFormHeaderId}-${field}`}
        >
          <div
            className={cn('row-between-center flex-1')}
            style={{
              minHeight: INPUT_ROW_HEIGHT,
            }}
          >
            <div className={'flex-1 text-left'}>{label}</div>
            <input
              type={'number'}
              min={'0'}
              value={value}
              className={cn('flex-1', classes.input, classes.textInput)}
              style={{
                width: 50,
              }}
              onChange={handleChangeSupplementOverride(field)}
              onInput={handleSupplementNameInputChange(selectedFormHeaderId)}
            />
          </div>
        </div>
      );
    });
  };
  /**
   * FUNCTIONS: EFFECTS
   */
  useEffect(() => {
    setupSupplementState();
    setupInitialClientState();
  }, [selectedClient, selectedClients.length]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if any dropdown is open
      const hasOpenDropdown = frPayableRows.some(row => row.dropdownOpen);
      
      if (hasOpenDropdown && !event.target.closest('[data-state-dropdown]')) {
        // Close all dropdowns
        setFrPayableRows(prevRows => 
          prevRows.map(row => ({ ...row, dropdownOpen: false }))
        );
      }
    };

    // Only add listener if there are open dropdowns
    const hasOpenDropdown = frPayableRows.some(row => row.dropdownOpen);
    if (hasOpenDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [frPayableRows.map(row => row.dropdownOpen).join(',')]);

  useEffect(() => {
    getClientListAsync();
    getSupplementsAsync();
    getProductsAsync();
    getStatesAsync();
  }, []);

  // Auto-set phoneInterview to true for IQ products with propertyTypeId 2
  useEffect(() => {
    if (!selectedProductId || !selectedPropertyTypeId || !selectedProductCategoryId) return;
    
    const productData = columnData?.[selectedPropertyTypeId]?.[selectedProductCategoryId]?.find(
      cat => cat.productId === selectedProductId,
    );
    
    // Check if this is an IQ product with propertyTypeId 2 and phoneInterview is not already set
    if (productData?.iqProduct && productData?.propertyTypeId === 2 && !productData?.phoneInterview) {
      const updatedColumnData = JSON.parse(JSON.stringify({ ...columnData }));
      const productNameIndex = getProductNameIndex(selectedPropertyTypeId, selectedProductCategoryId, selectedProductId);
      
      if (productNameIndex !== -1) {
        updatedColumnData[selectedPropertyTypeId][selectedProductCategoryId][productNameIndex].phoneInterview = true;
        setColumnData(updatedColumnData);
        setFilteredCategoryColumnData(updatedColumnData);
        setFilteredNameColumnData(updatedColumnData);
        addProductToModifiedList(selectedProductId);
      }
    }
  }, [selectedProductId, selectedPropertyTypeId, selectedProductCategoryId]);

  const changeUpdateState = event => {
    if (event.target.value == 'Wipe') {
      SetwipeUpdateCreate(false);
    }
    if (event.target.value == 'Update') {
      SetwipeUpdateCreate(true);
    }
  };

  const handleStateSelection = (stateValue) => {
    // Get the dropdown element and current scroll position
    const dropdownElement = document.querySelector('[data-state-dropdown] .dropdown-list');
    const currentScrollTop = dropdownElement?.scrollTop || 0;
    
    setSelectedStates(prev => {
      const newStates = prev.includes(stateValue) 
        ? prev.filter(s => s !== stateValue)
        : [...prev, stateValue];
      
      // Use setTimeout to restore scroll position after React re-renders
      setTimeout(() => {
        if (dropdownElement) {
          dropdownElement.scrollTop = currentScrollTop;
        }
      }, 0);
      
      return newStates;
    });
  };

  const handleSelectAllStates = () => {
    // Get the dropdown element and current scroll position
    const dropdownElement = document.querySelector('[data-state-dropdown] .dropdown-list');
    const currentScrollTop = dropdownElement?.scrollTop || 0;
    
    const newStates = selectedStates.length === stateOptions.length 
      ? [] 
      : stateOptions.map(state => state.value);
    
    setSelectedStates(newStates);
    
    // Use setTimeout to restore scroll position after React re-renders
    setTimeout(() => {
      if (dropdownElement) {
        dropdownElement.scrollTop = currentScrollTop;
      }
    }, 0);
  };

  const handleAddFRPayableRow = () => {
    const newRow = {
      id: Date.now(),
      selectedStates: [],
      dropdownOpen: false,
      amount: ''
    };
    setFrPayableRows(prev => [...prev, newRow]);
  };

  const handleRemoveFRPayableRow = (rowId) => {
    if (frPayableRows.length > 1) {
      setFrPayableRows(prev => prev.filter(row => row.id !== rowId));
    }
  };

  // Load FR payables when selecting a product (but don't auto-save to prevent loops)
  React.useEffect(() => {
    if (selectedProductId && allProductFRPayables[selectedProductId]) {
      setFrPayableRows(allProductFRPayables[selectedProductId]);
    } else if (selectedProductId) {
      // Reset to default when selecting a product with no saved payables
      setFrPayableRows([{ id: 1, selectedStates: [], dropdownOpen: false, amount: '' }]);
    }
  }, [selectedProductId, allProductFRPayables]);

  const handleRowStateSelection = (rowId, stateValue) => {
    // Get the dropdown element and current scroll position
    const dropdownElement = document.querySelector('[data-state-dropdown] .dropdown-list');
    const currentScrollTop = dropdownElement?.scrollTop || 0;
    
    setFrPayableRows(prev => {
      const updatedRows = prev.map(row => {
        if (row.id === rowId) {
          const newSelectedStates = row.selectedStates.includes(stateValue)
            ? row.selectedStates.filter(s => s !== stateValue)
            : [...row.selectedStates, stateValue];
          return { ...row, selectedStates: newSelectedStates };
        }
        return row;
      });
      
      // Use setTimeout to restore scroll position after React re-renders
      setTimeout(() => {
        if (dropdownElement) {
          dropdownElement.scrollTop = currentScrollTop;
        }
      }, 0);
      
      // Immediately save to allProductFRPayables if we have a selected product
      if (selectedProductId) {
        setAllProductFRPayables(prevAll => ({
          ...prevAll,
          [selectedProductId]: [...updatedRows]
        }));
        
        // Add to valid products if it has data
        if (updatedRows.some(row => row.selectedStates.length > 0 || row.amount)) {
          if (!validProductIds.has(selectedProductId)) {
            validProductIds.add(selectedProductId);
            setValidProductIds(new Set(validProductIds));
          }
        }
      }
      
      return updatedRows;
    });
  };

  const handleRowDropdownToggle = (rowId) => {
    setFrPayableRows(prev => prev.map(row => {
      if (row.id === rowId) {
        return { ...row, dropdownOpen: !row.dropdownOpen };
      }
      return { ...row, dropdownOpen: false }; // Close other dropdowns
    }));
  };

  const handleRowAmountChange = (rowId, amount) => {
    setFrPayableRows(prev => {
      const updatedRows = prev.map(row => {
        if (row.id === rowId) {
          return { ...row, amount };
        }
        return row;
      });
      
      // Immediately save to allProductFRPayables if we have a selected product
      if (selectedProductId) {
        setAllProductFRPayables(prevAll => ({
          ...prevAll,
          [selectedProductId]: [...updatedRows]
        }));
        
        // Add to valid products if it has data
        if (updatedRows.some(row => row.selectedStates.length > 0 || row.amount)) {
          if (!validProductIds.has(selectedProductId)) {
            validProductIds.add(selectedProductId);
            setValidProductIds(new Set(validProductIds));
          }
        }
      }
      
      return updatedRows;
    });
  };

  return (
    <>
      <Grid item xs={12} className={classes.container}>
        <Card className={cn('flex-1', 'flex-column')}>
          <CardHeader
            className={classes.cardHeader}
            titleTypographyProps={{ className: classes.cardHeaderTitle }}
            title={
              <div className="row-between-center">
                <div>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSaveChangesButton}
                    disabled={
                      !formIsReady || errorType.length > 0 || (!clientSingleSelectEnabled && counter === '0 selected')
                    }
                    className={cn('light-blue-background')}
                    style={{
                      marginRight: 10,
                      opacity:
                        !formIsReady || (!clientSingleSelectEnabled && counter === '0 selected') || errorType.length > 0
                          ? 0.65
                          : 1,
                    }}
                  >
                    {formIsSaving ? <CircularProgress color="#fff" size={18} /> : 'Save Changes'}
                  </Button>

                  {/* Price Overrides */}
                  {formIsLoading && <CircularProgress size={20} style={{ color: 'var(--jmi-blue)', marginLeft: 20 }} />}
                </div>
                <div className="flex-1 row-end-center">
                  <div className="flex-column">
                    <CardHeader
                      style={{ padding: 0 }}
                      titleTypographyProps={{ className: classes.cardHeaderTitle }}
                      title={
                        <FormControlLabel
                          label="Single Client Mode"
                          labelPlacement="start"
                          control={
                            <ColoredCheckbox
                              style={{ marginRight: 15 }}
                              checked={clientSingleSelectEnabled}
                              onChange={toggleClientSingleSelectEnabled}
                            />
                          }
                        />
                      }
                    />
                    <InfoTooltip title="Switches view from products to supplements">
                      <>
                        <CardHeader
                          style={{ padding: 0 }}
                          titleTypographyProps={{ className: classes.cardHeaderTitle }}
                          title={
                            <div>
                              <FormControlLabel
                                label="Supplement View"
                                labelPlacement="start"
                                control={<ColoredCheckbox checked={supplementView} onChange={toggleSupplementView} />}
                              />
                            </div>
                          }
                        />
                      </>
                    </InfoTooltip>
                  </div>
                  <div className="flex-1 col-start-start">
                    <div
                      style={{
                        color: '#aaa',
                        fontSize: 15,
                        visibility: clientSingleSelectEnabled ? 'hidden' : 'visible',
                      }}
                    >
                      {counter}
                    </div>

                    {clientSingleSelectEnabled ? (
                      <Autocomplete
                        loading={clientOptionsLoading || productsLoading}
                        options={clientOptions}
                        onChange={setSelectedClient}
                        value={selectedClient}
                        placeholder={'Select a client before continuing...'}
                        containerStyles={{ zIndex: 2 }}
                        maxHeight={'65px'}
                      />
                    ) : (
                      <Autocomplete
                        loading={clientOptionsLoading || productsLoading}
                        options={clientOptions}
                        onChange={val => setSelectedClients(val || [])}
                        value={selectedClients}
                        placeholder={'Select clients before continuing...'}
                        isMulti={true}
                        containerStyles={{ zIndex: 2 }}
                        closeMenuOnSelect={false}
                        components={{ ValueContainer }}
                        maxHeight={'65px'}
                      />
                    )}
                  </div>
                </div>
              </div>
            }
          />
          {/* Card for the radio buttons/checkbox */}
          {/** I can easily make this a radio button if that is better for UX */}
          <div>
            <CardHeader
              titleTypographyProps={{ className: classes.cardHeaderTitle }}
              title={
                <div className="flex-row row-between-center">
                  {!clientSingleSelectEnabled ? (
                    <FormControl>
                      <RadioGroup row onChange={changeUpdateState}>
                        <InfoTooltip
                          title="Clear all override settings for selected clients and create new override settings."
                          placement="top-end"
                        >
                          <>
                            <FormControlLabel
                              label="Create New"
                              labelPlacement="start"
                              value="Wipe"
                              control={<ColoredRadio />}
                              disabled={clientSingleSelectEnabled}
                            />
                          </>
                        </InfoTooltip>
                        <InfoTooltip
                          title="Update current override settings for selected clients and product (currently selected products will not be affected)"
                          placement="top-end"
                        >
                          <>
                            <FormControlLabel
                              label="Update"
                              labelPlacement="start"
                              value="Update"
                              control={<ColoredRadio />}
                              disabled={clientSingleSelectEnabled}
                              checked={wipeUpdateCreate}
                            />
                          </>
                        </InfoTooltip>
                      </RadioGroup>
                    </FormControl>
                  ) : (
                    <div className="row-start-end">
                      <FormControlLabel
                        control={
                          <ColoredCheckbox
                            onChange={toggleSelectProductEnabled}
                            checked={selectProduct}
                            disabled={!clientSingleSelectEnabled}
                          />
                        }
                        label={!supplementView ? 'Show Selected Products' : 'Show Selected Supplements'}
                        labelPlacement="start"
                      />
                    </div>
                  )}
                  {/* Export All Data button */}
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleExportData}
                    disabled={formIsLoading}
                    className={cn('light-blue-background')}
                    style={{
                      marginRight: 10,
                      opacity: formIsLoading ? 0.65 : 1,
                    }}
                  >
                    {exportingData ? <CircularProgress color="#fff" size={18} /> : 'Export All Data'}
                  </Button>
                </div>
              }
            />
          </div>
          <CardContent
            className={classes.table}
            style={{
              pointerEvents: !formIsReady || formIsSaving ? 'none' : 'auto',
              opacity: formIsReady ? 1 : 0.5,
            }}
          >
            {/* first column - product types */}
            {!supplementView ? (
              <div className={cn(classes.tableColumnSmall)}>
                <div className={classes.tableColumnHeader}>Property Types</div>
                <div className={classes.columnListContainer}>
                  {Object?.keys(filteredCategoryColumnData)
                    ?.filter(
                      type =>
                        !!Object.keys(filteredCategoryColumnData[type])?.filter(prod =>
                          filteredCategoryColumnData[type][prod]?.some(val =>
                            selectProduct ? validProductIds?.has(val.productId) : val,
                          ),
                        ).length,
                    )
                    ?.map(renderPropertyTypeCell)}
                </div>
              </div>
            ) : (
              <div className={cn(classes.tableColumnSmall)}>
                <div className={classes.tableColumnHeader}>Property Types</div>
                <div className={classes.columnListContainer}>
                  {Object.entries(filteredCategorySupplementData)
                    ?.filter(x =>
                      selectProduct
                        ? Object.values(x[1]).some(y => validFormHeaderIds?.has(y[0]?.formHeaderId))
                        : Object.values(x[1]),
                    )
                    .map(x => parseInt(x))
                    ?.map(renderPropertyTypeCell)}
                </div>
              </div>
            )}

            {/* second column - product categories */}
            {/** Does not get rendered for supplement view */}
            {!supplementView ? (
              <div
                className={cn(
                  classes.tableColumnSmall,
                  //   selectedCategoryId === null && classes.columnDisabled
                )}
              >
                <div className={classes.tableColumnInputHeader}>
                  <input
                    className={classes.inputHeader}
                    onChange={runCategoriesFilter} //? this.value == null : setFilteredColumnData(columnData)
                    id="productCategoriesFilter"
                    type="text"
                    placeholder="Category"
                    onFocus={e => (e.target.placeholder = '')}
                    onBlur={e => (e.target.placeholder = 'Category')}
                  ></input>
                  <SearchIcon className={classes.searchIcon} />
                </div>
                {!!selectedPropertyTypeId &&
                  Object?.keys(filteredCategoryColumnData[selectedPropertyTypeId])
                    ?.filter(prod =>
                      filteredCategoryColumnData[selectedPropertyTypeId][prod]?.some(val =>
                        selectProduct ? validProductIds?.has(val.productId) : val,
                      ),
                    )
                    ?.sort()
                    ?.map(renderProductCategoryCell)}
              </div>
            ) : (
              <div
                className={cn(
                  classes.tableColumnSmall,
                  //   selectedCategoryId === null && classes.columnDisabled
                )}
              >
                <div className={classes.tableColumnInputHeader}>
                  <input
                    className={classes.inputHeader}
                    onChange={runSupplementFilter} //? this.value == null : setFilteredSupplementData(supplementData)
                    id="suppNameFilter" // will need a replacement for this and above
                    type="text"
                    placeholder="Supplement Names"
                    onFocus={e => (e.target.placeholder = '')}
                    onBlur={e => (e.target.placeholder = 'Supplement Names')}
                  ></input>
                  <SearchIcon className={classes.searchIcon} />
                </div>
                {!!selectedPropertyTypeId &&
                  Object.entries(filteredCategorySupplementData[selectedPropertyTypeId])
                    .filter(supp => (selectProduct ? validFormHeaderIds.has(supp[1][0].formHeaderId) : supp))
                    .map(x => x[0])
                    .sort()
                    ?.map(renderSupplementNameCell)}
              </div>
            )}

            {/* third column - product names */}
            {/** Does not get rendered for supplement view */}
            {/** Instead of renderering nothing for supplement view, render overrides */}
            {!supplementView ? (
              <div
                className={cn(
                  classes.tableColumnMedium,
                  //   selectedCategoryId === null && classes.columnDisabled
                )}
                // rerenders the column so React doesn't cache previous products
              >
                <div className={classes.tableColumnInputHeader}>
                  <input
                    className={classes.inputHeader}
                    onChange={runNameFilter}
                    id="productNameFilter"
                    type="text"
                    placeholder="Name"
                    onFocus={e => (e.target.placeholder = '')}
                    onBlur={e => (e.target.placeholder = 'Name')}
                  ></input>
                  <SearchIcon className={classes.searchIcon} />
                </div>
                {!!selectedPropertyTypeId &&
                  !!selectedProductCategoryId &&
                  filteredNameColumnData[selectedPropertyTypeId][selectedProductCategoryId]
                    ?.filter(prod => (selectProduct ? validProductIds.has(prod.productId) : prod))
                    ?.sort((a, b) => a.productCode.localeCompare(b.productCode))
                    ?.map(renderProductNameCell)}
              </div>
            ) : (
              <>
                {/** Overrides for supplement view */}
                <div className={cn(classes.tableColumn, classes.recommendationFormColumn)}>
                  <div className={cn(classes.tableColumnHeader, 'row-center-center')}>
                    <div className="flex-1">Price Overrides</div>
                  </div>
                  <div className={classes.recommendationFormContainer}>
                    {!!selectedPropertyTypeId && !!selectedSupplementName && renderSupplementOverridesColumn()}
                  </div>
                  {/** this is the container */}
                </div>
              </>
            )}

            {/* fourth column - product configuration */}
            {!supplementView ? (
              <div className={cn(classes.tableColumn, classes.recommendationFormColumn)}>
                <div className={classes.tableColumnHeader}>Product Configuration</div>
                <div className={classes.recommendationFormContainer}>
                  {!!selectedPropertyTypeId &&
                    !!selectedProductCategoryId &&
                    !!selectedProductId &&
                    renderProductConfiguration()}
                </div>
              </div>
            ) : null}
          </CardContent>
        </Card>
      </Grid>
      <ConfirmationDialog
        minHeight={'50vh'}
        minWidth={'95vw'}
        maxWidth={false}
        visible={showSaveChangesModal}
        setVisibility={setSaveChangesModal}
        title={
          <div style={{
            textAlign: 'center',
            fontWeight: 'bold',
            fontSize: '18px',
            color: envTheme.isProduction ? 'inherit' : envTheme.colors.primary,
            backgroundColor: envTheme.isProduction ? 'transparent' : envTheme.colors.primary + '10',
            padding: envTheme.isProduction ? '0' : '8px',
            borderRadius: envTheme.isProduction ? '0' : '4px'
          }}>
            {clientSingleSelectEnabled
              ? 'Update overrides for ' + selectedClient?.label
              : counter === 1 + ' selected'
              ? wipeUpdateCreate
                ? 'Update overrides for ' + selectedClients[0]?.label
                : 'Create new overrides for ' + selectedClients[0]?.label
              : wipeUpdateCreate
              ? `Update overrides for ${counter} clients`
              : `Create new overrides for ${counter} clients`}
          </div>
        }
        style={{
          padding: 0,
          paddingTop: 0,
          borderTop: 'none',
          borderBottom: 'none',
          minHeight: '70vh',
          maxHeight: '70vh'
        }}
        cancelButton={
          <Button 
            onClick={() => setSaveChangesModal(false)} 
            disabled={formIsSaving}
            style={{ 
              backgroundColor: envTheme.colors.accent, 
              color: 'white',
              opacity: formIsSaving ? 0.65 : 1,
              '&:hover': {
                backgroundColor: envTheme.colors.accentHover,
              }
            }}
          >
            Cancel
          </Button>
        }
        acceptButton={
          <Button
            onClick={() => saveOverridesAsync()}
            disabled={formIsSaving}
            style={{
              backgroundColor: envTheme.colors.primary,
              color: 'white',
              minWidth: 160,
              opacity: formIsSaving ? .65 : 1,
              '&:hover': {
                backgroundColor: envTheme.colors.primaryHover,
              }
            }}
          >
            {formIsSaving ? <CircularProgress color="#fff" size={18} /> : 'Confirm Changes'}
          </Button>
        }
      >
        <TableContainer 
          component={Paper}
          style={{
            border: 'none',
            borderRadius: '8px',
            padding: 0,
            margin: 0,
            maxHeight: '70vh',
            overflow: 'auto'
          }}
        >
          <Table style={{ padding: 0, margin: 0 }} stickyHeader>
            <TableHead>
              <TableRow style={{
                backgroundColor: envTheme.isProduction ? '#f5f5f5' : '#ffffff'
              }}>
                <TableCell style={{ 
                  fontWeight: 'bold', 
                  width: '32px',
                  backgroundColor: envTheme.isProduction ? '#f5f5f5' : '#ffffff',
                  borderBottom: envTheme.isProduction ? '1px solid #e0e0e0' : `2px solid ${envTheme.colors.primary}`
                }}></TableCell>
                <TableCell style={{ 
                  fontWeight: 'bold',
                  backgroundColor: envTheme.isProduction ? '#f5f5f5' : '#ffffff',
                  color: envTheme.isProduction ? 'inherit' : envTheme.colors.primary,
                  borderBottom: envTheme.isProduction ? '1px solid #e0e0e0' : `2px solid ${envTheme.colors.primary}`
                }}>Product</TableCell>
                <TableCell style={{ 
                  fontWeight: 'bold',
                  backgroundColor: envTheme.isProduction ? '#f5f5f5' : '#ffffff',
                  color: envTheme.isProduction ? 'inherit' : envTheme.colors.primary,
                  borderBottom: envTheme.isProduction ? '1px solid #e0e0e0' : `2px solid ${envTheme.colors.primary}`
                }}>Tier 1</TableCell>
                <TableCell style={{ 
                  fontWeight: 'bold',
                  backgroundColor: envTheme.isProduction ? '#f5f5f5' : '#ffffff',
                  color: envTheme.isProduction ? 'inherit' : envTheme.colors.primary,
                  borderBottom: envTheme.isProduction ? '1px solid #e0e0e0' : `2px solid ${envTheme.colors.primary}`
                }}>Tier 2</TableCell>
                <TableCell style={{ 
                  fontWeight: 'bold',
                  backgroundColor: envTheme.isProduction ? '#f5f5f5' : '#ffffff',
                  color: envTheme.isProduction ? 'inherit' : envTheme.colors.primary,
                  borderBottom: envTheme.isProduction ? '1px solid #e0e0e0' : `2px solid ${envTheme.colors.primary}`
                }}>Tier 3</TableCell>
                <TableCell style={{ 
                  fontWeight: 'bold',
                  backgroundColor: envTheme.isProduction ? '#f5f5f5' : '#ffffff',
                  color: envTheme.isProduction ? 'inherit' : envTheme.colors.primary,
                  borderBottom: envTheme.isProduction ? '1px solid #e0e0e0' : `2px solid ${envTheme.colors.primary}`
                }}>Tier DIY</TableCell>
              </TableRow>
            </TableHead>
                         <TableBody>
               {changes.validProducts?.map((row, index) => {
                 const hasIqSummary =
                   row.convertProduct ||
                   row.convertToProductId ||
                   row.homeOwnerDueDays ||
                   row.dueDateDays ||
                   row.cancelQVOnHOReject ||
                   row.convertToVirtualOnReject ||
                   row.disableInteriorPhotos;
                 const hasExpandableDetails =
                   (row.frAdditionalPayables?.length > 0) ||
                   row.qaPayableAmount ||
                   row.callAhead ||
                   row.phoneInterview ||
                   row.incompleteInterviewFrstipend ||
                   row.maxLocations ||
                   row.removeBetterView ||
                   row.removeHazardHub ||
                   row.removeQuantarium ||
                   row.alias ||
                   hasIqSummary;
                 const convertToProductCode =
                   row.convertToProductId != null &&
                   row.convertToProductId !== '' &&
                   products.find(p => p.productId == row.convertToProductId)?.productCode;

                 return (
                 <React.Fragment key={index}>
                   <TableRow style={{ cursor: 'pointer' }}
                            onClick={() => {
                              const newExpandedProducts = [...(expandedProducts || [])];
                              const productIndex = newExpandedProducts.indexOf(index);
                              if (productIndex > -1) {
                                newExpandedProducts.splice(productIndex, 1);
                              } else {
                                newExpandedProducts.push(index);
                              }
                              setExpandedProducts(newExpandedProducts);
                            }}>
                    <TableCell style={{ width: '32px', textAlign: 'center', padding: '8px 4px' }}>
                      {hasExpandableDetails && (
                         (expandedProducts || []).includes(index) ? (
                           <ExpandMore 
                             fontSize="small" 
                             
                             style={{ 
                               color: '#666'
                             }} 
                           />
                         ) : (
                           <ChevronRight 
                             fontSize="small" 
                             style={{ 
                               color: '#666'
                             }} 
                           />
                         )
                       )}
                     </TableCell>
                     <TableCell>
                       <div>
                         {row.productCode}
                         <div style={{ fontSize: '0.8em' }}>{row.productName}</div>
                       </div>
                     </TableCell>
                     <TableCell>{row.tier1 ? '$' + row.tier1 : ' '}</TableCell>
                     <TableCell>{row.tier2 ? '$' + row.tier2 : ' '}</TableCell>
                     <TableCell>{row.tier3 ? '$' + row.tier3 : ' '}</TableCell>
                     <TableCell>{row.tierDIY ? '$' + row.tierDIY : ' '}</TableCell>
                   </TableRow>
                   {(expandedProducts || []).includes(index) && hasExpandableDetails && (
                     <TableRow>
                        <TableCell colSpan={6} style={{ backgroundColor: 'white', padding: '0', borderTop: '1px solid #dee2e6' }}>
                         <div style={{ display: 'flex' }}>
                           <div style={{ width: '190px' }}></div>
                           <div style={{ 
                             flex: 1, 
                             backgroundColor: '#f8f9fa', 
                             padding: '15px',
                             borderLeft: '1px solid #dee2e6'
                           }}>
                             <div style={{ display: 'flex', gap: '40px', alignItems: 'flex-start' }}>
                           {/* Payables Section */}
                           {((row.frAdditionalPayables && row.frAdditionalPayables.length > 0) || row.qaPayableAmount) && (
                             <div style={{ flex: 1 }}>
                               <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>Payables:</div>
                               
                               {/* QA Payable */}
                               {row.qaPayableAmount && (
                                 <div style={{ 
                                   marginBottom: '8px', 
                                   paddingLeft: '20px',
                                   fontSize: '14px'
                                 }}>
                                   <span><strong>QA Payable:</strong> ${row.qaPayableAmount}</span>
                                 </div>
                               )}
                               
                               {/* FR Additional Payables */}
                               {row.frAdditionalPayables && row.frAdditionalPayables.length > 0 && (
                                 <div style={{ marginBottom: '8px' }}>
                                   <div style={{ 
                                     paddingLeft: '20px',
                                     fontSize: '14px',
                                     marginBottom: '5px'
                                   }}>
                                     <strong>Field Rep Payables:</strong>
                                   </div>
                                  {row.frAdditionalPayables.map((payable, payableIndex) => (
                                    <div key={payableIndex} style={{ 
                                      paddingLeft: '40px',
                                      marginBottom: row.frAdditionalPayables.length > 1 ? '10px' : '5px',
                                      paddingBottom: row.frAdditionalPayables.length > 1 && payableIndex < row.frAdditionalPayables.length - 1 ? '10px' : '0',
                                      borderBottom: row.frAdditionalPayables.length > 1 && payableIndex < row.frAdditionalPayables.length - 1 ? '1px solid #9ca3ab' : 'none',
                                      fontSize: '14px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '10px'
                                    }}>
                                      <span style={{ fontWeight: 'bold' }}>${payable.payableAmount || '0'}</span>
                                      <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
                                        {payable.stateAbbrs?.map(state => (
                                          <span key={state} style={{
                                            backgroundColor: envTheme.colors.primary,
                                            color: 'white',
                                            padding: '2px 8px',
                                            borderRadius: '12px',
                                            fontSize: '12px',
                                            fontWeight: 'bold',
                                            border: `1px solid ${envTheme.colors.primaryDark}`
                                          }}>
                                            {state}
                                          </span>
                                        ))}
                                      </div>
                                    </div>
                                  ))}
                                 </div>
                               )}
                             </div>
                           )}

                           {/* General Options */}
                           {(row.callAhead || row.removeBetterView || row.removeHazardHub || row.removeQuantarium || row.alias) && (
                             <div style={{ flex: 1 }}>
                               <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>General Options:</div>
                               <div style={{ 
                                 display: 'flex', 
                                 flexDirection: 'column',
                                 gap: '8px', 
                                 fontSize: '14px',
                                 paddingLeft: '20px'
                               }}>
                                 {row.alias && (
                                   <span><strong>Report Name Alias:</strong> {row.alias}</span>
                                 )}
                                 {row.callAhead && (
                                   <span><strong>Call Ahead:</strong> ✓</span>
                                 )}
                                 {row.removeBetterView && (
                                   <span><strong>Remove BetterView:</strong> ✓</span>
                                 )}
                                 {row.removeHazardHub && (
                                   <span><strong>Remove HazardHub:</strong> ✓</span>
                                 )}
                                 {row.removeQuantarium && (
                                   <span><strong>Remove Quantarium:</strong> ✓</span>
                                 )}
                               </div>
                             </div>
                           )}

                           {/* Phone Interview + IQ Options (third column) */}
                           {(row.phoneInterview ||
                             row.incompleteInterviewFrstipend ||
                             row.maxLocations ||
                             hasIqSummary) && (
                             <div style={{ flex: 1 }}>
                               {(row.phoneInterview ||
                                 row.incompleteInterviewFrstipend ||
                                 row.maxLocations) && (
                                 <>
                                   <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                                     Phone Interview Options:
                                   </div>
                                   <div
                                     style={{
                                       display: 'flex',
                                       flexDirection: 'column',
                                       gap: '8px',
                                       fontSize: '14px',
                                       paddingLeft: '20px',
                                     }}
                                   >
                                     {row.phoneInterview && (
                                       <span>
                                         <strong>Require Phone Interview:</strong> ✓
                                       </span>
                                     )}
                                     {row.incompleteInterviewFrstipend && (
                                       <span>
                                         <strong>Interview Completed Field Rep Reduction:</strong> $
                                         {row.incompleteInterviewFrstipend}
                                       </span>
                                     )}
                                     {row.maxLocations != null && row.maxLocations !== '' && (
                                       <span>
                                         <strong>Max Number Of Locations:</strong> {row.maxLocations}
                                       </span>
                                     )}
                                   </div>
                                 </>
                               )}
                               {hasIqSummary && (
                                 <div
                                   style={{
                                     marginTop:
                                       row.phoneInterview ||
                                       row.incompleteInterviewFrstipend ||
                                       row.maxLocations
                                         ? '16px'
                                         : 0,
                                   }}
                                 >
                                   <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>IQ Options:</div>
                                   <div
                                     style={{
                                       display: 'flex',
                                       flexDirection: 'column',
                                       gap: '8px',
                                       fontSize: '14px',
                                       paddingLeft: '20px',
                                     }}
                                   >
                                     {row.homeOwnerDueDays != null && row.homeOwnerDueDays !== '' && (
                                       <span>
                                         <strong>Owner Due Days:</strong> {row.homeOwnerDueDays}
                                       </span>
                                     )}
                                     {row.disableInteriorPhotos && (
                                       <span>
                                         <strong>Disable Interior Photos:</strong> ✓
                                       </span>
                                     )}
                                     {row.cancelQVOnHOReject && (
                                       <span>
                                         <strong>Cancel IQ On Owner Reject:</strong> ✓
                                       </span>
                                     )}
                                     {row.convertToVirtualOnReject && (
                                       <span>
                                         <strong>Convert To Virtual On Owner Reject:</strong> ✓
                                       </span>
                                     )}
                                     {row.convertProduct && (
                                       <span>
                                         <strong>Convert Product on Owner Reject:</strong> ✓
                                       </span>
                                     )}
                                     {row.convertToProductId != null && row.convertToProductId !== '' && (
                                       <span>
                                         <strong>Convert To Product:</strong>{' '}
                                         {convertToProductCode || row.convertToProductId}
                                       </span>
                                     )}
                                     {row.dueDateDays != null && row.dueDateDays !== '' && (
                                       <span>
                                         <strong>Due Date Days:</strong> {row.dueDateDays}
                                       </span>
                                     )}
                                   </div>
                                 </div>
                               )}
                             </div>
                           )}
                             </div>
                           </div>
                         </div>
                       </TableCell>
                     </TableRow>
                   )}
                 </React.Fragment>
               );
               })}
             </TableBody>
            <TableHead>
              <TableRow style={{
                backgroundColor: envTheme.isProduction ? '#f5f5f5' : '#ffffff'
              }}>
                <TableCell style={{ 
                  fontWeight: 'bold', 
                  width: '32px',
                  backgroundColor: envTheme.isProduction ? '#f5f5f5' : '#ffffff',
                  borderBottom: envTheme.isProduction ? '1px solid #e0e0e0' : `2px solid ${envTheme.colors.primary}`
                }}></TableCell>
                <TableCell style={{ 
                  fontWeight: 'bold',
                  backgroundColor: envTheme.isProduction ? '#f5f5f5' : '#ffffff',
                  color: envTheme.isProduction ? 'inherit' : envTheme.colors.primary,
                  borderBottom: envTheme.isProduction ? '1px solid #e0e0e0' : `2px solid ${envTheme.colors.primary}`
                }}>Supplement</TableCell>
                <TableCell style={{
                  backgroundColor: envTheme.isProduction ? '#f5f5f5' : '#ffffff',
                  borderBottom: envTheme.isProduction ? '1px solid #e0e0e0' : `2px solid ${envTheme.colors.primary}`
                }}></TableCell>
                <TableCell style={{
                  backgroundColor: envTheme.isProduction ? '#f5f5f5' : '#ffffff',
                  borderBottom: envTheme.isProduction ? '1px solid #e0e0e0' : `2px solid ${envTheme.colors.primary}`
                }}></TableCell>
                <TableCell style={{
                  backgroundColor: envTheme.isProduction ? '#f5f5f5' : '#ffffff',
                  borderBottom: envTheme.isProduction ? '1px solid #e0e0e0' : `2px solid ${envTheme.colors.primary}`
                }}></TableCell>
                <TableCell style={{ 
                  fontWeight: 'bold',
                  backgroundColor: envTheme.isProduction ? '#f5f5f5' : '#ffffff',
                  color: envTheme.isProduction ? 'inherit' : envTheme.colors.primary,
                  borderBottom: envTheme.isProduction ? '1px solid #e0e0e0' : `2px solid ${envTheme.colors.primary}`
                }}>Price</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {changes.validSupplements?.map((row, index) => (
                <TableRow key={index}>
                  <TableCell style={{ width: '32px' }}></TableCell>
                  <TableCell>{row.supplementName}</TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell>{row.price ? '$' + row.price : ' '}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </ConfirmationDialog>
    </>
  );
};

ClientPriceOverrides.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(withRouter(ClientPriceOverrides));
